export default __webpack_public_path__ + "1ceebf2cb61456c3b2db013338f49891.svg";